// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_caseclassification_adjust_already_placed_order25 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const en_us2_caseclassification_adjust_already_placed_order25 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const de_de2_caseclassification_adjust_already_placed_order25 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aenderung`)
};

const en_caseclassification_adjust_already_placed_order25 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const de_caseclassification_adjust_already_placed_order25 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aenderung`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const caseclassification_adjust_already_placed_order25 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.caseclassification_adjust_already_placed_order25(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("caseclassification_adjust_already_placed_order25", locale)
	if (locale === "en-GB") return en_gb2_caseclassification_adjust_already_placed_order25(inputs)
	if (locale === "en-US") return en_us2_caseclassification_adjust_already_placed_order25(inputs)
	if (locale === "de-DE") return de_de2_caseclassification_adjust_already_placed_order25(inputs)
	if (locale === "en") return en_caseclassification_adjust_already_placed_order25(inputs)
	return de_caseclassification_adjust_already_placed_order25(inputs)
};
export { caseclassification_adjust_already_placed_order25 as "caseClassification.ADJUST_ALREADY_PLACED_ORDER" }